import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingInventryService } from '@apiServices';
import { first } from 'rxjs/operators';
import { ModalPopup, PackagingType } from '../../constants/constants';
import { KrollCheckQuantity } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLength } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

@Component({
  selector: 'app-change-packaging-popup',
  templateUrl: './change-packaging-popup.component.html',
  styleUrls: ['./change-packaging-popup.component.scss']
})
export class ChangePackagingPopupComponent implements OnInit {
  @Output() action: EventEmitter<any> = new EventEmitter();
  form!: FormGroup;
  isCopy = new FormControl(false);
  PackagingType = PackagingType;
  inventryType: { rx_inventory_types: any[], ship_inventory_types: any[] } = {
    rx_inventory_types: [],
    ship_inventory_types: [],
  }
  location: { all_states: any[], rx_states: any[], ship_states: any[] } = {
    all_states: [],
    rx_states: [],
    ship_states: [],
  }
  isLoading: boolean = false;
  old_ids: number[] = [];
  isDisabled: boolean = false;
  showQtyError: boolean = false;
  rxQtyErrors: number[] = [];
  constructor(
    public dialogRef: MatDialogRef<ChangePackagingPopupComponent>,
    public helperService: HelperService,
    public shippingInventryService: ShippingInventryService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.form = this.fb.group({
      sale_order_rx_packagings: this.fb.array([], arrayMinLength(1))
    });
    if (this.props?.sale_order_rx_packagings?.length > 0)
      this.initializeForm();
    else
      this.addPackaging(PackagingType.Ship);
  }
  ngOnInit(): void {
    this.getLocation();
    this.getInventryType();
  }
  initializeForm() {
    this.old_ids = this.props.sale_order_rx_packagings.map((f: any) => f.id);
    let control = <FormArray>this.form.controls.sale_order_rx_packagings;
    this.props.sale_order_rx_packagings.forEach((x: any) => {
      control.push(this.fb.group({
        id: new FormControl(x.id),
        InventoryTypeID: new FormControl(x.InventoryTypeID, Validators.compose([Validators.required])),
        Quantity: new FormControl(+x.Quantity, x.ShipType == PackagingType.RX ? Validators.compose([Validators.required, Validators.min(1)]) : Validators.compose([Validators.nullValidator])),
        SalesOrderID: new FormControl(x.SalesOrderID, Validators.compose([Validators.required])),
        ShipType: new FormControl(x.ShipType, Validators.compose([Validators.required])),
        StateID: new FormControl(x.StateID, Validators.compose([Validators.required])),
      }));
    });
  }
  addPackaging(packagingType: string) {
    let control = <FormArray>this.form.controls.sale_order_rx_packagings;
    let firstStateIndexId = this.form.value.sale_order_rx_packagings.find((f: any) => f.ShipType == PackagingType.RX)?.StateID;
    control.push(this.fb.group({
      id: new FormControl(0),
      InventoryTypeID: new FormControl(null, Validators.compose([Validators.required])),
      Quantity: new FormControl(1, (packagingType == PackagingType.RX) ? Validators.compose([Validators.required, Validators.min(1)]) : Validators.compose([Validators.nullValidator])),
      SalesOrderID: new FormControl(this.props.sale_order_rx_packagings[0]?.SalesOrderID ?? this.props.ID),
      ShipType: new FormControl(packagingType, Validators.compose([Validators.required])),
      StateID: new FormControl(this.isCopy.value ? firstStateIndexId : null, Validators.compose([Validators.required])),
    }));
  }
  get sale_order_rx_packagings_arr() {
    return this.form.controls['sale_order_rx_packagings'] as FormArray;
  }
  get isMultipleRXPackaging() {
    return this.form.value.sale_order_rx_packagings.filter((f: any) => f.ShipType == PackagingType.RX)?.length >= 1 ? false : true;
  }
  getFormName(index: number) {
    return this.sale_order_rx_packagings_arr.controls[index] as FormGroup;
  }
  remove = (index: number, val: any) => {
    let control = <FormArray>this.form.controls.sale_order_rx_packagings;
    control.removeAt(index)
    let errorIndex = this.rxQtyErrors.findIndex(f => f === index);
    if (control.length === 1) {
      this.rxQtyErrors = [];
    }
    else if (errorIndex >= 0) {
      if (!this.rxQtyErrors.includes(index + 1)) {
        this.rxQtyErrors.splice(errorIndex, 1);
      }
    }
  }
  getInventryType() {
    this.shippingInventryService.inventryType.subscribe(res => this.inventryType = res);
  }
  getLocation() {
    this.shippingInventryService.location.subscribe(res => this.location = res);
  }
  formSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      let obj: { packagings: any[], old_ids: any[] } = {
        "packagings": this.form.value.sale_order_rx_packagings,
        "old_ids": this.old_ids.filter((f: any) => f > 0)
      }
      this.krollService.save_sales_order_packaging(obj).subscribe(res => {
        if (res.body.success) {
          this.isLoading = false;
          this.dialogRef.close();
          this.action.emit({ data: res.body.data, ModalPopup: ModalPopup.ChangePackaging });
        }
        else {
          this.isLoading = false;
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

  onSelectionChange(event: any, index: number, shipType: string, controlName: string): void {
    this.showQtyError = false;
    let form = this.getFormName(index);
    if (form.valid) {
      const obj: KrollCheckQuantity = {
        InventoryTypeID: controlName === 'InventoryTypeID' ? event.value : form.controls.InventoryTypeID.value,
        StateID: controlName === 'StateID' ? event.value : form.controls.StateID.value,
        ShipType: shipType,
        Quantity: this.getQuantity(event, shipType, controlName, form),
        SalesOrderID: form.controls.SalesOrderID.value
      };
      this.checkStatus(obj, shipType, index);
    }
  }

  getQuantity(event: any, shipType: any, controlName: any, form: any) {
    if (shipType === PackagingType.Ship) {
      return 1
    }
    if (controlName === 'Quantity') {
      return Number(event.target.value)
    } else {
      return form.controls.Quantity.value
    }
  }

  checkStatus(obj: KrollCheckQuantity, shipType: string, index: number): void {
    this.krollService.checkQuantity(obj).pipe(first()).subscribe((res: any) => {
      if (res.body?.success) {
        this.isDisabled = false;
        if (shipType === PackagingType.Ship) {
          this.showQtyError = false;
        }
        else {
          let errorIndex = this.rxQtyErrors.findIndex(f => f === index);
          this.rxQtyErrors.splice(errorIndex, 1);
        }
      }
      else {
        this.isDisabled = true;
        if (shipType === PackagingType.Ship) {
          this.showQtyError = true;
        }
        else {
          let isExists = this.rxQtyErrors.find(f => f === index);
          if (!isExists) {
            this.rxQtyErrors.push(index);
          }
        }
      }
    });
  }

  getselectedCheck(index: number, id: number, formControl: string): boolean {
    let form = this.getFormName(index);
    if (form.controls.StateID.value && formControl === 'InventoryTypeID' || form.controls.InventoryTypeID.value && formControl === 'StateID') {
      let filteredForm = formControl === 'InventoryTypeID' ? this.sale_order_rx_packagings_arr.controls.filter((f: any) => f.controls.StateID.value === form.controls.StateID.value && f.controls.InventoryTypeID.value === id && f != form) :
        this.sale_order_rx_packagings_arr.controls.filter((f: any) => f.controls.InventoryTypeID.value === form.controls.InventoryTypeID.value && f.controls.StateID.value === id && f != form);
      return filteredForm && filteredForm.length > 0 ? true : false;
    }
    else {
      return false;
    }
  }
}
